import { Checkbox, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ProductItemWrapper = styled.div<{
  selected: boolean;
  selectionMode: boolean;
  isNewDesign: boolean | null;
}>`
  height: 100%;
  position: relative;
  padding: ${({ selectionMode, isNewDesign }) =>
    selectionMode && !isNewDesign ? '3px 1px' : '0'};
  border-radius: ${({ selected, isNewDesign }) =>
    selected && !isNewDesign ? '2px' : '0'};
  border: ${({ selected, isNewDesign }) =>
    selected && !isNewDesign
      ? `2px solid ${theme.color.border.selected}`
      : 'none'};
`;

export const StyledCheckbox = styled(Checkbox)`
  display: block;
`;

export const ClickBlocker = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
`;
